module.exports = __webpack_public_path__ + "img/奖章4级@2x.bf63ae96.png";